module.exports = __webpack_public_path__ + "media/hyper/images/help-icon-152a10a09c89e1bf8abebf29123018d8.svg";